export default __webpack_public_path__ + "9d4b054529e0967dae463d841b137e0f.png";